export const config = {
  ENVIRONMENT: process.env.ENVIRONMENT,
  GOOGLE_CLIENT_ID: process.env.GOOGLE_CLIENT_ID,
  MEMBER_WEBSITE_URL: process.env.MEMBER_WEBSITE_URL,
  ADMIN_WEBSITE_URL: process.env.ADMIN_WEBSITE_URL,
  ATC_WEBSITE_URL: process.env.ATC_WEBSITE_URL,
};
